// "Before your shift" (architecture sprint-14 §8.4; solution.md "SOP checklist", verbatim). `{origin}` is
// replaced by window.location.origin when rendered. Bold runs are marked with ** like the brief.

export const SOP_TITLE = 'Before your shift';
export const SOP_PATH = '/shifts/before-your-shift';

export const SHIFT_SOP_STEPS: readonly string[] = [
  'Use a **laptop or desktop**, plugged in. Phones are not supported.',
  '**Power plan**: never sleep when plugged in. Closing the lid does nothing. Screen off is fine, sleep is not.',
  '**Edge**: Settings → System and performance → "Never put these sites to sleep" → add {origin}. **Chrome**: Settings → Performance → Memory Saver → "Always keep these sites active" → add {origin}.',
  '**Volume** up and not muted. Speakers, or headphones you are wearing. **Focus Assist / Do Not Disturb off**, and browser notifications allowed for Clockit.',
  'Keep **one Clockit tab** open all shift. Don\'t close the browser. After a restart, click "Arm alarms".',
  'Press **Test sound** at the start of every shift.',
];

export interface SopRun {
  text: string;
  bold: boolean;
}

/** Splits a step into plain and bold runs, with {origin} filled in. */
export function sopRuns(step: string, origin: string): SopRun[] {
  return step
    .split('{origin}')
    .join(origin)
    .split('**')
    .map((text, i) => ({ text, bold: i % 2 === 1 }))
    .filter((r) => r.text !== '');
}
